import { NearRPCProviderService } from "@/services/rpc/near";

export const ONE_YOCTO = "1";

export class NonFungibleTokenContract {
  readonly contractId: string;
  private provider: NearRPCProviderService;

  constructor(contractId: string) {
    this.contractId = contractId;
    this.provider = new NearRPCProviderService();
  }

  async getUserNFT(address: string, limit: number, from: string) {
    return this.provider.viewFunction("nft_tokens_for_owner", this.contractId, {
      account_id: address,
      limit,
      from_index: from,
    });
  }

  async getUserNFTIds(address?: string, limit?: number, from?: string) {
    const nfts = await this.getUserNFT(address ?? "", limit ?? 100, from ?? "0");
    return nfts?.map((el) => el.token_id) ?? [];
  }
}
